import { createFileRoute, redirect } from "@tanstack/react-router";

/** Sales moved from /crm to /sales; old links (emails, bookmarks) keep their query string. */
export const Route = createFileRoute("/_authenticated/crm/")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: `/sales${location.searchStr}`, replace: true });
  },
  staticData: { page: "sales" },
});
